<template>
    <div class="all">
        <div class="container">
            <div class="grid h-auto">
                <div class="grid-header">
                    <h2 class="title">常见问题</h2>
                </div>
                <div class="grid-body mt20">
                    <div class="problem">
                        <dl v-for="(item,index) in helpList" :key="index">
                            <dt class="clearfix">
                                <i class="sign sign-red fl">问</i>
                                <div class="hidden">{{item.question}}</div>
                            </dt>
                            <dd class="mt15 clearfix">
                                <i class="sign sign-green fl">答</i>
                                <div style="padding-left:30px;" v-html="item.answer"></div>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data() {
        return {
          helpList:[]
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            this.getHelplist();
        }) 
    },
    created() {
		
    },
    methods: {
        getHelplist(){
            let that = this;
            that.$api.get('/help/list?type=2', {}, r => {
                that.$parent.returnCode(r,function(){
                    that.helpList = r.data
                });
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/problem.vue